var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 10.1538V17.5385C20.0002 18.1913 19.7408 18.8174 19.2792 19.279C18.8176 19.7407 18.1915 20 17.5386 20H6.46172C5.80888 20 5.18278 19.7407 4.72115 19.279C4.25952 18.8174 4.00018 18.1913 4.00018 17.5385V10.1538",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C3.67358 4 3.36052 4.12967 3.12971 4.36048C2.8989 4.5913 2.76923 4.90435 2.76923 5.23077V7.69231H21.2308V5.23077C21.2308 4.90435 21.1011 4.5913 20.8703 4.36048C20.6395 4.12967 20.3264 4 20 4Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4617 11.3846C14.4617 11.711 14.332 12.0241 14.1012 12.2549C13.8704 12.4857 13.5574 12.6154 13.2309 12.6154H10.7694C10.443 12.6154 10.1299 12.4857 9.89912 12.2549C9.66831 12.0241 9.53864 11.711 9.53864 11.3846C9.53864 11.0582 9.66831 10.7451 9.89912 10.5143C10.1299 10.2835 10.443 10.1538 10.7694 10.1538H13.2309C13.5574 10.1538 13.8704 10.2835 14.1012 10.5143C14.332 10.7451 14.4617 11.0582 14.4617 11.3846Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.5c63cfc310ab4dc8890e198b3313ce3d.svg";
export { ForwardRef as ReactComponent };